export default __webpack_public_path__ + "static/media/frame_right_dark.217dcb62.png";